"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSHashesRMD = void 0;
const jshashes_1 = __importDefault(require("jshashes"));
class JSHashesRMD {
    constructor() {
        this.rmd160base64func = new jshashes_1.default.RMD160().b64;
        this.rmd160hexfunc = new jshashes_1.default.RMD160().hex;
    }
    rmd160base64(text) {
        return this.rmd160base64func(text);
    }
    rmd160hex(text) {
        return this.rmd160hexfunc(text);
    }
    rmd160base64impl() {
        return this.rmd160base64func;
    }
    rmd160heximpl() {
        return this.rmd160hexfunc;
    }
}
exports.JSHashesRMD = JSHashesRMD;
//# sourceMappingURL=JSHashesRMD.js.map